import { useEffect, useState } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'
import useUiOverlayStore from '../store/useUiOverlayStore'

/**
 * ScrollToTop Component
 * Automatically scrolls to top of page on route changes
 * Should be placed inside Router but outside Routes
 *
 * Note: Не сбрасывает позицию для /cases и возврата в каталог /teams.
 * Прячется, пока открыт любой фуллскрин-оверлей (useUiOverlayStore).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()
  const [showScrollButton, setShowScrollButton] = useState(false)
  const overlayOpen = useUiOverlayStore((state) => state.overlayCount > 0)

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [pathname])

  useEffect(() => {
    const shouldRestoreTeams = pathname === '/teams'
      && navigationType === 'POP'
      && sessionStorage.getItem('teamCatalogReturn')

    // У кейсов своя логика; каталог банд восстанавливает позицию после загрузки данных
    if (pathname !== '/cases' && !shouldRestoreTeams) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      })
    }

    setShowScrollButton(false)
  }, [pathname, navigationType])

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  const visible = showScrollButton && !overlayOpen && !pathname.endsWith('/opening-multi')

  return (
    <button
      type="button"
      onClick={handleScrollToTop}
      className={`fixed right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-black/50 text-gray-300 shadow-lg shadow-black/30 backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:border-white/20 hover:bg-black/70 hover:text-gray-200 focus:outline-none focus:ring-0 ${visible ? 'pointer-events-auto bottom-24 opacity-100 lg:bottom-6' : 'pointer-events-none bottom-20 opacity-0 lg:bottom-6'}`}
    >
      <span className="text-xl leading-none">↑</span>
    </button>
  )
}

export default ScrollToTop
